import { postApi } from "@/utils/http";
import Vue from "vue";
import { _order } from "@/utils/order";
import { getReversed } from "../utils/order";

export default {
  namespaced: true,
  state: { computers: [], groups: [], domainUID: null },
  mutations: {
    setDomainUID(state, { domainUID }) {
      state.domainUID = domainUID;
    },
    mergeComputer(state, { c, obj }) {
      const index = state.computers.findIndex((x) => x.uid === c.uid);
      if (index !== -1) {
        const item = state.computers[index];
        Vue.set(state.computers, index, { ...item, ...obj });
      } else if (obj) state.computers.unshift(obj);
    },
    editComputer(state, data) {
      const { c, obj } = data;
      const index = state.computers.findIndex((x) => x.uid === c.uid);
      const item = state.computers[index];
      Vue.set(state.computers, index, { ...item, ...obj });
    },
    replaceComputer(state, c) {
      const index = state.computers.findIndex((x) => x.uid === c.uid);
      Vue.set(state.computers, index, c);
    },
    addComputer(state, computer) {
      state.computers.unshift(computer);
    },
    removeComputer(state, computerUID) {
      const index = state.computers.findIndex((x) => x.uid === computerUID);
      if (index !== -1) Vue.delete(state.computers, index);
    },
    set(state, data) {
      if (data) {
        state.computers = data.computers;
        state.groups = data.groups;
      }
    },
    setComputers(state, computers) {
      state.computers = computers;
    },
    clear(state) {
      state.groups = [];
      state.computers = [];
      state.domainUID = null;
    },
  },
  actions: {
    async fetch(
      { commit, state, dispatch, rootState },
      { domainUID, force = false }
    ) {
      if (force || domainUID !== state.domainUID) {
        commit("setDomainUID", { domainUID }); //state.domainUID = domainUID;

        const res = await postApi("get/domainComputers", {
          domainUID: domainUID,
        });

        if (res) {
          await dispatch(
            "settings/getUserSetting",
            { path: "computers", key: "order" },
            { root: true }
          );

          const items = {
            computers: _order(
              res[0]?.computers,
              rootState.settings.user.computers?.order
            ),
            groups: res[0]?.groups,
          };

          commit("set", items);
        }
      }
    },
    async delete({ commit }, { computerUID, domainUID }) {
      const res = await postApi("delete/computer", {
        domainUID: domainUID,
        uid: computerUID,
      });

      commit("removeComputer", computerUID);
    },
    async fetchComputer({ commit }, { domainUID, computerUID }) {
      const res = await postApi("get/domainComputer", {
        domainUID: domainUID,
        computerUID: computerUID,
      });

      if (res[0] && res[0][0])
        commit("mergeComputer", { c: { uid: res[0][0].uid }, obj: res[0][0] });
    },
    async mergeComputer({ commit }, { c, obj }) {
      commit("mergeComputer", { c, obj });
    },
    async order({ dispatch, commit, state, rootState }, order) {
      const stateOrder = rootState.settings.user.computers?.order;

      order = getReversed(stateOrder, order);

      dispatch(
        "settings/setUser",
        { path: "computers", key: "order", value: order },
        { root: true }
      );

      commit("setComputers", _order(state.computers, order));
    },
  },
  getters: {
    singleComputer: (state) => (computerUID) => {
      return state.computers.find((x) => x.uid === computerUID);
    },
    singleGroup: (state) => (groupUID) => {
      return state.groups.find((x) => x.uid === groupUID);
    },
  },
  modules: {},
};
